import companyMutations from './mutations.js';
import companyActions from './actions.js';
import companyGetters from './getters.js';
// import { mapMutations, mapActions, mapGetters } from 'vuex';


export default {
    namespaced: true,
    state() {
        return {
            companies: [],
            next: null,
            prev: null,
            count: null,
            isLoading: false,
            page: null,
            pageSize: null,
            showCreateCompanyForm: false,
            activeFilters: [],
            showFilterPane: true,
            showBasicFilters: true,
            showCampaignFilters: true,
            showResearchFilters: true,
            showBulkOperationsPane: true,
            showStatusSummaryPane: false,
            showCRMSummaryStages: false,
            crmSummaryStagesClient: null,
            showTableFilters: true,
            activeFiltersVisible: true,
            showMyOpenTasks: {show: false, user: null},
            refetchCompanies: false,
            visibleFilters: { 
                companyNameFilter: true,
                companyDescriptionFilter: true,
                companyWebsiteUrlFilter: true,
                companyAddressFilter: true,
                companySourcesFilter: true,
                companyCampaignFilter: true,
                companyCampaignExcludeFilter: true,
                companyCampaignWorkflowStatusFilter: true,
                companyTierFilter: true,
                companyClientFeedbackFilter: true,
                companyResearchStatusFilter: true,
                companyResearchStatusFilterTwo: true,
                companyRevenueFilter: true,
                companyHeadcountFilter: true,
                companyRevenueZiCombinedFilter: true,
                companyClientFilter: true,
                companyCRMStatusFilter: true,
                companyPreviousCRMStatusFilter: true,
                companyCollectionTagsFilter: true,
                companyCollectionTagSourcesFilter: true,
                companyCRMNextActionFilter: true,
                companyDueTimeRangeFilter: true,
                companyStateFilter: true,
                companyDrivingTimeFocusFilter: true,
                companyDrivingTimeFilter: true,
                companyNAICSFilter: true,
                companyTaskUserFilter: true,
                companyShowResearchHaltedFilter: true,
                companyParentCompanyStatusFilter: true,
                companyInvestorsStatusFilter: true,
                companyProblemStatusFilter: true,
                companyAccountManagerResearchNotesFilter: true,
                showMyTasksFilter: true,
                companyIdFilter: true,
                companyCategoryFilter:true,
                companyRelevantBusinessFilter:true,
                companyReferralSourceFilter:true,
                companyReferralStatusFilter:true,
                companyProductServiceCodeFilter:true,
                companyContractPSCKeywordFilter:true,
                companyContractNAICSKeywordFilter:true,
                companyContractAwardingSubAgencyFilter:true,
                companyCRMActionsFilter:true,
                companyCollectionTagExcludeFilter:true,
                companyHasCRMActionsFilter:true,
                companyHasConflictsFilter:true,
                companyParentTypeFilter:true,
                companyCollectionReviewFilter: true,
                companyPreviousCampaignFilter: true,
                companyCageCodeFilter: true,
                companyUeiSamFilter: true,
                companyCountryFilter: true,
                companyRegionsFilter: true,
                companyCampaignChangeREquestorFilter: true,
                companySourcesExcludeFilter: true,
                companyEnrichedAfterFilter: true,
                companyZiRevenueFilter: true,
                companyContactPhoneFilter: true,
                companyCRMStatusDateFilter: true,
                companyPMAMakeFilter: true,
                companyPMAModelFilter: true,
                // 05/12/25 - Company Cleanup: filters removed
                // companyOnboardingStatusFilter: true,
                // companyDNRReasonFilter: true,
                // companyBusinessTypeFilter: true,
                // companySectorFilter: true,
                // companySubSectorFilter: true,
                // companySourceOwnerFilter: true,
                // companyIgpCategoryFilter: true,
                // companyEveraxisPillarFilter:true,
                // companyCapabilitiesFilter:true,
            }
        };
    },
    mutations: companyMutations,
    actions: companyActions,
    getters: companyGetters
    // ...mapMutations['companyMutations'],
    // ...mapActions['companyActions'],
    // ...mapGetters['companyGetters'],
};